var render = function render(){
  var _vm$program;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [(_vm$program = _vm.program) !== null && _vm$program !== void 0 && _vm$program._id ? [_c('expo-program-dashboard')] : _vm._e(), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "dark": false,
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": "5",
      "color": "primary"
    }
  })], 1)], 1)], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }